<!-- 选择建筑房间组件 支持每级建筑选择，支持最后一集选择 -->
<template>

    <div style="position: relative;">
        <div class="newres-select el-input el-input--medium" @click.stop="handleOpen">
            <p class="el-input__inner" style="display:inline-block;cursor: pointer;position: relative;">
                <span>{{value}}</span>
                <span class="placeholder" v-if="value == ''">请选择楼宇</span>
                <i class="el-icon-error el-icon--right" v-else style="position: absolute;right: 10px;top: 11px;" @click.stop="clearValue"></i>
            </p>
        </div>
        <transition name="fade">
            <div class="select-box" v-if="isOpenResidence" v-clickoutside="handleOpenF">
                <div class="build-header">
                    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
                        <el-tab-pane
                            v-for="(item, index) in tabList"
                            :key="index"
                            :label="item.typename"
                            :name="item.oid"
                        >
                        </el-tab-pane>
                    </el-tabs>
                </div>
                <div class="build-body" v-loading="loading">
                    <template v-for="(v, i) in dataList">
                        <span class="build-item icon-btn" :key="i" @click="handleClickRoom(v)">{{v.modulename}}</span>
                    </template>
                    <div v-if="dataList.length==0" style="margin:10px auto;text-align:center;color:#ccc;font-size:14px;">暂无数据。<router-link to="/residence">完善楼宇数据</router-link></div>
                </div>
            </div>
        </transition>
    </div>

</template>

<script>
import Service from '@/api/Service'

export default {
    name: "CmpBuildSelectMeter",
    props: ["buildRoom", "changeOnSelect"],     //  buildRoom: 初始值；changeOnSelect：是否支持每级查询
    data() {
        return {
            value: '',  //  显示内容
            choseValue: [],
            choseItem: {},
            isOpenResidence: false,     //  建筑列表框

            tabList: [],   //  选项头部

            dataList: [],   //  建筑列表
            isRoom: false,  // 是否点击房间

            activeName: 0,
            loading: false,
			roomarr:[],
			building_index:0,
        };
    },
    created() {
        this.initData();
    },
    watch: {
        buildRoom: {
            handler(newName, oldName) {
                this.initData()
            },
            immediate: true,
            deep: true
        }
    },
    methods: {
        initData() {
           
        },
        // 获取列表
        async getListData(oid, isendpoint) {
            let data
            this.loading = true;    //  开启加载动画
            if(isendpoint){
                // 获取房间
				this.$store.dispatch("GetProjectInfo").then(async res => {
				    // 获取模型结构
				    Service.getTemplate({oid:res.buildings_template_id}).then(async ress => {
						this.roomarr = this.fmdata(JSON.parse(ress.description))
						this.building_index=this.roomarr[this.roomarr.length - 1].id
						data = await Service.getHouseList({OID: this.addForm.previous,building_index:this.building_index,house_name:''});
						data = data === 'success' ? [] : data;
						data.map(v=>{
						   v.modulename = v.housename
						})
						if(data){
						    this.dataList = data;
						    this.setTab(oid, data[0]);
						}
				    })
				}).catch(res=>{
					
				})
                
                this.isRoom = true;
            }else{
                // 获取建筑
                let res = await Service.getBuildList({OID: oid});
                data = res.list === null ? [] : res.list;
                this.isRoom = false;
				if(data){
				    this.dataList = data;
				    this.setTab(oid, data[0]);
				}
            }
            this.loading = false;   //  关闭加载动画
        },
		fmdata(data){
			return data.reduce((arr, { id, typename, children = [] }) =>
				arr.concat([{ id, typename }], this.fmdata(children)), [])
		},
        // 打开建筑框   重置数据
        handleOpen() {
            this.choseValue = [];
            this.choseItem = {};
            this.tabList = [];
            this.isOpenResidence = true;
            this.getListData(0);
        },
        // 关闭建筑框
        handleOpenF() {
            this.isOpenResidence = false;
            if(this.choseItem.housename){
                // 最后一级确认信息
                this.$emit('listenBuildResult', this.choseItem)
                this.value = this.choseValue.join(' / ');
            }else{
                if(this.changeOnSelect == ''){
                    // 当前级确认信息
                    this.$emit('listenBuildResult', this.choseItem)
                }
            }
        },
        // 清空
        clearValue() {
            this.value = "";
            this.choseItem = {};
            this.handleOpen();
        },
        // 点击建筑
        handleClickRoom(item) {
            this.choseItem = item;
            this.choseValue.push(item.modulename);
            // 是最后一级则关闭
            if(item.isendpoint){
                this.handleOpenF();
            }
            if(item.housename){
                // 确认房间信息
                this.handleOpenF();
            }else{
                if(this.changeOnSelect == '') {
                    this.value = this.choseValue.join(' / ');
                }
                // 获取下级数据
                this.getListData(item.oid, item.isendpoint);
            }
        },
        // 设置头部tab
        setTab(oid, item){
            if(!item) return
            this.tabList.push({
                oid: oid + "",
                typename: item.typename || "房间"
            })
            this.activeName = oid + "";
        },
        // 点击头部tab
        handleClick(tab, event) {
            if(event) {
                event.stopPropagation ? event.stopPropagation(): event.cancelBubble = true;
            }
            let index = tab.index
            let oid = tab.name;
            this.tabList = this.tabList.filter((v,i)=>{
                return i<index
            })
            this.choseValue = this.choseValue.filter((v,i)=>{
                return i<index
            })
            this.value = this.choseValue.join(' / ');
            this.getListData(oid);
        }
    }
};
</script>

<style scoped>
.select-box {
    position: absolute;
    width: 100%;
    padding: 12px 24px;
    border: 1px solid #ddd;
    background: #fff;
    box-sizing: border-box;
    z-index: 9999;
    box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
    border-radius: 4px;
}
.build-body{
    line-height: 28px;
    font-size: 0;
}
.build-item{
    display: inline-block;
    margin: 0 10px;
    font-size: 14px;
}


</style>
